import _defaultRatingsBoards from 'rlink-regions/ratingsBoards';
import Region from 'rlink-regions/Region';

export default function getRegionForCountry (countryCode, skuGroups, regionRestrictions = {}, ratingsBoards = _defaultRatingsBoards) {
  if (!skuGroups) {
    throw new Error('Must provide app skuGroups to getRegionForCountry');
  }
  let skuGroup, regionRestriction, ratingsBoard;
  for (let [key, skuGroupCountries] of Object.entries(skuGroups)) {
    if (skuGroupCountries.includes(countryCode)) {
      skuGroup = key;
    }
  }

  for (let [key, ratingsBoardCountries] of Object.entries(ratingsBoards)) {
    if (ratingsBoardCountries.includes(countryCode)) {
      ratingsBoard = key;
    }
  }

  for (let [key, regionRestrictionCountries] of Object.entries(regionRestrictions)) {
    if (regionRestrictionCountries.includes(countryCode)) {
      regionRestriction = key;
    }
  }

  return new Region(skuGroup, ratingsBoard, regionRestriction);
}



// WEBPACK FOOTER //
// ./lib/rlink-regions/getRegionForCountry.js